import { PRODUCT_STATUS } from '../productsStatus';
import Loader from '../../../../../components/Loader/Loader';
import Popup from '../../../../../components/Popup/Popup';
import React from 'react';
export var ProductCrossActivationButton = function ProductCrossActivationButton(_ref) {
  var status = _ref.status,
      inverted = _ref.inverted;

  switch (status) {
    case PRODUCT_STATUS.LOADING:
      return /*#__PURE__*/React.createElement(Loader, {
        inverted: true,
        inline: true,
        size: "small",
        className: "product-loader"
      });

    case PRODUCT_STATUS.CAN_ACTIVATE:
      return /*#__PURE__*/React.createElement("div", {
        "data-qa": "try-now-info",
        className: "product-info"
      }, "try now");

    case PRODUCT_STATUS.ACCESS_NEEDED:
      return /*#__PURE__*/React.createElement(Popup, {
        trigger: /*#__PURE__*/React.createElement("div", {
          "data-qa": "request-access-info",
          className: "product-info"
        }, "request access"),
        position: 'top center',
        flowing: true,
        inverted: inverted
      }, /*#__PURE__*/React.createElement(Popup.Content, null, /*#__PURE__*/React.createElement("div", {
        className: "cloud-ui-nav-tooltip"
      }, "Ask the owner for access or switch to an organization with access to the product.")));

    default:
      return null;
  }
};